import React from 'react'

import { Portlet, Row, Col, Button, Form } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as InventariosService from 'services/inventario.service'

import { DownloadAxiosFile } from 'utils'

const ReporteProduccion = () => {
  const __zariContext = React.useContext(ZariContext)

  const [fechaDesde, setfechaDesde] = React.useState(new Date())
  const [fechaHasta, setfechaHasta] = React.useState(new Date())
  const [flagDetallado, setflagDetallado] = React.useState(true)
  const [flagEntradas, setflagEntradas] = React.useState(false)
  const [flagSalidas, setflagSalidas] = React.useState(false)
  const [opciones, setOpciones] = React.useState('Detallado')
  const [resultados, setResultados] = React.useState(null)
  const [buscando, setBuscando] = React.useState(false)

  const getParams = () => ({ fechaDesde, fechaHasta, opciones })

  const clickDescargarReporte = React.useCallback(() => {
    __zariContext.loader.open('Descargando reporte de Producción...')
    InventariosService.descargarReporteProduccion(getParams())
      .then(({ data, headers }) => { DownloadAxiosFile.downloadAsBlob(data, headers) })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => { __zariContext.loader.close() })
  }, [fechaDesde, fechaHasta, opciones, __zariContext])

  const clickBuscar = React.useCallback(() => {
    setBuscando(true)
    InventariosService.consultaProduccion(getParams())
      .then(({ data }) => setResultados(data))
      .catch(({ data }) => __zariContext.snack('error', data?.error || 'Error al consultar'))
      .finally(() => setBuscando(false))
  }, [fechaDesde, fechaHasta, opciones, __zariContext])

  return (
    <Portlet>
      <Portlet.Header title='Reporte de Produccion' />
      <Portlet.Body>
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='Desde' htmlFor='desde' md={4} />
              <Col md={6}>
                <Form.InputDate value={fechaDesde} name='fechaDesde' id='date-desde' onChange={e => setfechaDesde(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='Hasta' htmlFor='hasta' md={4} />
              <Col md={6}>
                <Form.InputDate value={fechaHasta} name='fechaHasta' id='date-hasta' onChange={e => setfechaHasta(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={6} className='text-left'>
            <Form.Radio id='checkbox-entradas' name='checkbox-entradas' checked={flagEntradas} label='Entradas'
              onClick={() => { setflagEntradas(true); setflagSalidas(false); setflagDetallado(false); setOpciones('Entradas') }} />
            <Form.Radio id='checkbox-salidas' name='checkbox-salidas' checked={flagSalidas} label='Salidas'
              onClick={() => { setflagEntradas(false); setflagSalidas(true); setflagDetallado(false); setOpciones('Salidas') }} />
            <Form.Radio id='checkbox-detallado' name='checkbox-detallado' checked={flagDetallado} label='Detallado'
              onClick={() => { setflagEntradas(false); setflagSalidas(false); setflagDetallado(true); setOpciones('Detallado') }} />
          </Col>
          <Col md={6} className='text-right'>
            <Button variant='outline-primary' onClick={clickBuscar} disabled={buscando} className='mr-2'>
              {buscando ? 'Buscando...' : 'Buscar'}
            </Button>
            <Button onClick={clickDescargarReporte}>Descargar Reporte</Button>
          </Col>
        </Row>

        {resultados && (
          <Row className='mt-3'>
            <Col md={12}>
              <div style={{ maxHeight: 500, overflowY: 'auto' }}>
                <table className='table table-sm table-striped table-bordered'>
                  <thead>
                    <tr>
                      <th>FECHA</th>
                      <th>NUMERO</th>
                      <th>CODIGO</th>
                      <th>DESCRIPCION</th>
                      <th className='text-right'>CANTIDAD</th>
                      <th>U.M.</th>
                      <th>TIPO</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultados.map((r, i) => (
                      <tr key={i}>
                        <td>{r.fecha}</td>
                        <td>{r.numero}</td>
                        <td>{r.codigo}</td>
                        <td>{r.descripcion}</td>
                        <td className='text-right'>{r.cantidad}</td>
                        <td>{r.unidad}</td>
                        <td>{r.tipo}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <small className='text-muted'>{resultados.length} registros encontrados</small>
            </Col>
          </Row>
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ReporteProduccion)
